import React from 'react';
import '../../../assets/css/common/video/index.css';
import VideoDiscuss from './discuss.js';

import {connect} from 'react-redux';

class VideoDetail extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			Ol_Name: "",
			Ol_Intro: "",
			Detail: "",
			detailHeight: 0
		}
		this.discussStyle = {display: 'none'}
		
	}
	componentDidMount() {
		let Docheight = document.documentElement.clientHeight?document.documentElement.clientHeight:document.body.clientHeight;
		let hei1 = parseInt(this.getHeight(document.querySelector(".video"), 'height'));
		let hei2 = parseInt(this.getHeight(document.querySelector(".quick-nav"), 'height'));
		let hei3 = parseInt(this.getHeight(document.querySelector(".video-content"), 'height'));
		let hei4 = parseInt(this.getHeight(document.querySelector(".sub-header"), 'height'));
		
		let Height = Docheight-hei1-hei2-hei3-hei4*2.65;
		this.setState({
			detailHeight: Height
		})
		//console.log(this.props.state.outlineId.outlineXQ)
		if(this.state.Ol_Name == '' && this.props.state.outlineId.outlineXQ){
			this.setState({
				Ol_Name: this.props.state.outlineId.outlineXQ.Ol_Name,
				Ol_Intro: this.props.state.outlineId.outlineXQ.Ol_Intro,
				Detail: this.props.state.outlineId.outlineXQ.Detail
			})
		}
	}
	getHeight( obj, style ){
	　　return window.getComputedStyle(obj).getPropertyValue(style);
	}
	componentWillReceiveProps (newProps) {
		if(newProps.state.outlineId.outlineXQ){
			this.setState({
				Ol_Name: newProps.state.outlineId.outlineXQ.Ol_Name,
				Ol_Intro: newProps.state.outlineId.outlineXQ.Ol_Intro,
				Detail: newProps.state.outlineId.outlineXQ.Detail
			})
		}
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	componentDidUpdate(){
		//在组件完成更新后立即调用
		let font = document.querySelectorAll('.detail-row-content font');
		let h1 = document.querySelectorAll('.detail-row-content h1');
		font.forEach(item => {
			if(item.size > 3){
				item.size = parseInt(item.size/2);
			}
		})
		h1.forEach(item => {
			item.style.fontSize = '0';
		})
	}
	discuss(display){
		this.setState(
			this.discussStyle = display
		)
	}
	render() {
		return(
			<div className={'detail'}>
				<div className={'detail-row'}>
				{
					// <div className={'detail-row-title'}>
					// 	详情
					// </div>
				}
					
					<div className={'detail-row-content'}>
						<div dangerouslySetInnerHTML={{
							__html: this.state.Detail
						}}
						></div>
					</div>
				</div>
			{
				// <div className={'detail-row'}>
				// 	<div className={'detail-row-title'}>
				// 		{this.state.Ol_Name}
				// 	</div>
				// 	<div className={'detail-row-content'}>
				// 		{this.state.Ol_Intro}
				// 	</div>
				// </div>
				
//					<div className={'detail-foot'}>
//						<div onClick={this.discuss.bind(this,{display: 'block'})}>
//							<img src={require('../../../assets/images/video/xq1.svg')} alt="图片" />
//							<span>2104</span>
//						</div>
//						<div>
//							<img src={require('../../../assets/images/video/xq2.svg')} alt="图片" />
//							<span>2104</span>
//						</div>
//						<div>
//							<img src={require('../../../assets/images/video/xq3.svg')} alt="图片" />
//							<span>2104</span>
//						</div>
//					</div>
				}
				
				<VideoDiscuss discussStyle={this.discussStyle} display={this.discuss.bind(this)} />
		    </div>
		);
	}
}
export default connect((state)=>{
	return {
		state: state
	}
})(VideoDetail)